import { SettingValue, useFeatureFlag as useConfigCatFeatureFlag } from 'configcat-react';
import { useConfigCatUser } from 'contexts/configcat/ConfigCatUserContext';

/**
 * Wrapper around configcat-react's useFeatureFlag that automatically
 * passes the current user from ConfigCatUserContext.
 */
export function useFeatureFlag(key: string, defaultValue = false) {
    const user = useConfigCatUser();
    return useConfigCatFeatureFlag(key, defaultValue, user);
}

export function useFeatureFlagSetting<T extends SettingValue>(
    key: string,
    defaultValue: T,
) {
    const user = useConfigCatUser();
    return useConfigCatFeatureFlag(key, defaultValue, user);
}
